import React from 'react';
import _get from 'lodash/get';
import { Typography, makeStyles } from '@material-ui/core';
import Badge from 'components/Badge';
import { getImageFile } from 'utils/stringUtils';

const useStyles = makeStyles(theme => ({
  plainCardContainer: {
    display: 'flex',
    flexGrow: 1,
    padding: 10,
    marginBottom: 20,
    borderRadius: 8,
    border: '1px solid #E9ECED',
  },
  imageContainer: {
    width: 64,
    height: 64,
    borderRadius: 10,
    overflow: 'hidden',
    flexShrink: 0,
    marginRight: 20,

    '& > img': {
      maxWidth: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  badgeContainer: {
    color: props =>
      props.style === 'Wide Card'
        ? theme.palette.text.white
        : theme.palette.primary.main,
    height: 'auto',
    '& span': {
      color: 'inherit',
      paddingTop: 0,
    },
  },
  plainCardTitle: {
    ...theme.typography.h5,
    fontSize: '1.125rem',
  },
  richText: {
    '& p': {
      ...theme.typography.pxSmall,
    },
  },
}));

export const SeriesPreviewCard = ({ item }) => {
  const classes = useStyles();

  const { title } = _get(item, 'fields', {});
  const backgroundImage = getImageFile(
    _get(item, 'fields') || _get(item, 'fields.list.fields.0.fields'),
  );

  return (
    <div className={classes.plainCardContainer}>
      <div className={classes.imageContainer}>
        <img src={backgroundImage} alt="Series" />
      </div>
      <div display="flex" justifyContent="space-between">
        <Badge customClasses={classes} removeMargin type="series" />
        <Typography className={classes.plainCardTitle} color="textPrimary">
          {title}
        </Typography>
      </div>
    </div>
  );
};
